<template>
    <div class="home-search-component">
        <div class="row main-row">
            <div class="col-md-6" :class="onlysearch ? 'only-search':''">
                <div class="home-search-box" v-if="!showFranchiseeRegister">
                    <h1>{{ __("A mais completa imobiliária de Curitiba, agora em todo o Brasil e Paraguai") }}</h1>
                    <h2>{{ __("Conheça nossas franquias imobiliárias") }}</h2>
                    <!-- lang == 'ptBR' -->
                    <form action="">

                        <div class="business-button">
                            <label 
                                class="business_button" 
                                :class="filters.business == 'Vendas' ? 'checked':''" 
                                for="business_vendas"
                                @click="()=>{filters.business_subfilter = 'Residencial'; clearFilter(true)}"
                            >
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.75016 1.3335C5.07416 1.3335 2.0835 4.32416 2.0835 8.00016C2.0835 11.6762 5.07416 14.6668 8.75016 14.6668C12.4262 14.6668 15.4168 11.6762 15.4168 8.00016C15.4168 4.32416 12.4262 1.3335 8.75016 1.3335ZM7.4175 10.9422L4.94216 8.47216L5.8835 7.52816L7.41616 9.05816L10.9455 5.52883L11.8882 6.4715L7.4175 10.9422Z" fill="#312C73"/>
                                </svg>
                                <span>{{ __("Comprar") }}</span>
                                <input name="business" v-model="filters.business" type="radio" value="Vendas" id="business_vendas"/>
                            </label>

                            <label 
                                class="business_button" 
                                :class="filters.business == 'Locacao' ? 'checked':''" 
                                for="business_locacao"
                                @click="()=>{filters.business_subfilter = 'Mensal'; clearFilter(true)}"
                            >
                                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.75016 1.3335C5.07416 1.3335 2.0835 4.32416 2.0835 8.00016C2.0835 11.6762 5.07416 14.6668 8.75016 14.6668C12.4262 14.6668 15.4168 11.6762 15.4168 8.00016C15.4168 4.32416 12.4262 1.3335 8.75016 1.3335ZM7.4175 10.9422L4.94216 8.47216L5.8835 7.52816L7.41616 9.05816L10.9455 5.52883L11.8882 6.4715L7.4175 10.9422Z" fill="#312C73"/>
                                </svg>
                                <span>{{ __("Alugar") }}</span>
                                <input name="business" v-model="filters.business" type="radio" value="Locacao" id="business_locacao"/>
                            </label>
                            <button @click.prevent="toggleFranchiseeRegisterSection" class="be-a-franchisee-button">
                                {{ __("Seja Franqueado") }}
                            </button>
                        </div>

                        <div v-if="filters.business" class="business-sub-filters" :class="`business-${filters.business}`">
                            <div 
                                v-for="sub,subkey in _business_subfilters" 
                                class="button"
                                :class="filters.business_subfilter == sub.label ? 'checked' : ''"
                                v-bind:key="`sub_${sub.label}_${subkey}`"
                                @click="onSubfilterClick(sub.label)">
                                {{__(sub.label)}}
                            </div>
                        </div>

                        <div class="main-filters input-filters" :class="!show_other_types ? 'no-border':''">

                            <div v-if="filter_by_ref" class="row">
                                <div class="col-md-12">
                                    <div class="input">
                                        <label class="use_icon reference" for="">
                                            <span class="text">Código</span>
                                        </label>
                                        
                                        <VSelectInfinite
                                            :options="filters_options.references"
                                            :placeholder="'Procurar por código'"
                                            v-model="filters.reference"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div v-show="!use_advanced_filters && !filter_by_ref" class="row">
                                <div class="col-md-12">
                                    <div class="input search_by">
                                        <label class="use_icon gps" for="">
                                            <span class="text">{{ __("Buscar por:") }}</span>
                                        </label>
                                        <VSelectInfinite
                                            ref="vselectsearchby"
                                            :options="filters_options.open_search"
                                            :placeholder="__('Bairro, cidade, endereço ou referência')"
                                            v-model="filters.open_search"
                                            v-on:input="handleOpenSearch"
                                            :min_search="true"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div v-show="use_advanced_filters && !filter_by_ref" class="row">
                                <div class="col-md-12">
                                    <div class="input">
                                        <label class="use_icon pin" for="">
                                            <span class="text">{{__("Cidade")}}</span>
                                        </label>
                                         <VSelectInfinite
                                            ref="vselectcity"
                                            :options="citiesOptions"
                                            :placeholder="__('Procurar por cidade')"
                                            v-model="filters.city"
                                            v-on:input="() => {filters.district = []}"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div v-show="use_advanced_filters && !filter_by_ref" class="row">
                                <div class="col-md-12">
                                    <div class="input">
                                        <label class="use_icon target" for="">
                                            <span class="text">{{ __("Bairro") }}</span>
                                        </label>


                                        <VSelectMultipleVue
                                            :placeholder="__('Procurar por bairro')"
                                            v-model="filters.district"
                                            :options="districtOptions"
                                            v-on:input="changePropertyTypeCombo()"
                                            :empty_label="filters.city ? 'Nenhuma opção encontrada.': 'Nenhuma cidade selecionada.'"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2" v-show="!use_advanced_filters && visual_types && visual_types.length > 0">
                                <div class="col-12">
                                    <div class="business-visual-types">
                                        <div 
                                            v-for="type,idx in visual_types" 
                                            v-bind:key="`visual-type-${idx}`" 
                                            class="visual-type" 
                                            :class="getVisualTypeClass(type)"
                                            v-on:click="()=>{handlePropertyTypeButtons(type.id);}"
                                        >
                                            <img :width="type.size.split('x')[0]" :height="type.size.split('x')[1]" :alt="type.label" :src="type.img"/>
                                            <span>{{ __(type.label) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-show="!show_other_types && filters.business_subfilter != 'Temporário'" class="row trigger-property-types">
                                <div class="col-md-12">
                                    <div @click="()=>{show_other_types = !show_other_types}" class="others-properties-types">
                                        <h6>{{ __("Outros imóveis") }}</h6>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.18499 7.68499C5.54297 7.32701 6.12337 7.32701 6.48135 7.68499L9.99984 11.2035L13.5183 7.68499C13.8763 7.32701 14.4567 7.32701 14.8147 7.68499C15.1727 8.04297 15.1727 8.62337 14.8147 8.98135L10.648 13.148C10.29 13.506 9.70964 13.506 9.35166 13.148L5.18499 8.98135C4.82701 8.62337 4.82701 8.04297 5.18499 7.68499Z" fill="#333333"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <div v-show="!filter_by_ref && show_other_types" class="row property-types-wrapper">
                                <div class="col-md-12">
                                    <div class="input">
                                        <label class="use_icon house" for="">
                                            <span class="text">{{__("Tipo de imóveis:")}}</span>
                                        </label>

                                        <VSelectMultipleVue
                                            :placeholder="__('Selecione o tipo de imóvel')"
                                            v-model="filters.property_type"
                                            :options="property_type_purpose"
                                            v-on:input="changePropertyTypeCombo()"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div v-show="use_advanced_filters && !filter_by_ref" class="row">
                                <div class="col-6 float-field">
                                    <div class="input">
                                        <label class="use_icon money" for="">
                                            <span class="text">Valor Min</span>
                                        </label>
                                        <input v-money="moneyMask" v-model="filters.price_min" type="text" :placeholder="__('Valor Mínimo')">
                                    </div>
                                </div>

                                <div class="col-6 float-field">
                                    <div class="input">
                                        <label class="use_icon money" for="">
                                            <span class="text">Valor Max</span>
                                        </label>
                                        <input v-money="moneyMask" v-model="filters.price_max" type="text" :placeholder="__('Valor Máximo')">
                                    </div>
                                </div>
                            </div>


                            <div v-show="use_advanced_filters && !filter_by_ref" class="row">
                                <div class="col-6 float-field">
                                    <div class="input">
                                        <label class="use_icon bed" for="">
                                            <span class="text">{{__('Quartos')}}</span>
                                        </label>

                                        <VSelectMultipleVue
                                            :placeholder="__('Nº de quartos')"
                                            v-model="filters.bedrooms"
                                            :options="numeric_options(4, __('quartos'))"
                                        />
                                    </div>
                                </div>

                                
                                <div class="col-6 float-field">
                                    <div class="input">
                                        <label class="use_icon car" for="">
                                            <span class="text">{{__('Vagas')}}</span>
                                        </label>

                                        <VSelectMultipleVue
                                            :placeholder="__('Nº de vagas')"
                                            v-model="filters.garage"
                                            :options="numeric_options(4, __('vagas'), '', true)"
                                        />

                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- <div v-if="lang=='ptBR'" class="row">
                            <div class="col-6">
                                <div @click="()=>{use_advanced_filters = !use_advanced_filters; loadExistingFilters(true); show_other_types=true;}" class="button-change-form use_icon filter" :class="use_advanced_filters ? 'close-filter':''">
                                    <span class="text" v-html="use_advanced_filters? __('Fechar filtros avançados'): __('Filtros Avançados')" ></span>
                                </div>
                            </div>

                            <div  class="col-6">
                                <div @click="clearFilter()" class="button-change-form use_icon clear_filters">
                                    <span class="text" v-html="__('Limpar filtros')" ></span>
                                </div>
                            </div>
                        </div> -->

                        <div class="row mt-2">
                            <div class="col-md-12">
                                <div  @click="search" class="filter-button use_icon search">
                                    <span>{{ __("Encontrar imóveis") }}</span>
                                </div>
                            </div>
                        </div>
                        
                    </form>
                </div>
                <div class="home-franchisee-links-box" v-if="showFranchiseeRegister">
                    <h1>{{ __("Faça parte da franquia imobiliária que está revolucionando o Brasil") }}</h1>
                    <h2>{{ __("Conheça nossas franquias imobiliárias") }}</h2>
                    <div class="content-wrapper">
                        <div class="business-button">
                            <button 
                                class="business_button" 
                                @click.prevent="toggleFranchiseeSectionWithOption('Residencial')"
                            >
                                <span>{{ __("Comprar") }}</span>
                            </button>

                            <button 
                                class="business_button" 
                                @click.prevent="toggleFranchiseeSectionWithOption('Mensal')"
                            >
                                <span>{{ __("Alugar") }}</span>
                            </button>
                            <button @click.prevent="toggleFranchiseeRegisterSection" class="be-a-franchisee-button">
                                {{ __("Seja Franqueado") }}
                            </button>
                        </div>
                        <div class="content-links-bloc">
                            <a href="https://franqueado.apolar.com.br/" target="_blank" class="content-link-item">
                                <div class="content-link-icon-box">
                                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_15244_32144)">
                                        <path d="M45.8009 8.24916C45.3532 7.90348 45.1666 7.32942 45.3257 6.78667C45.8672 5.1107 44.5098 3.24254 42.7487 3.23954C42.1832 3.22304 41.695 2.86827 41.5045 2.33565C40.9574 0.66146 38.7612 -0.0520164 37.3346 0.98079C36.8675 1.29965 36.2639 1.29975 35.7969 0.98079C34.3701 -0.0521103 32.1741 0.661648 31.627 2.33565C31.4366 2.86827 30.9483 3.22304 30.3829 3.23954C28.6216 3.24254 27.2644 5.1108 27.8058 6.78667C27.9648 7.32942 27.7783 7.90348 27.3305 8.24916C25.9075 9.28693 25.9075 11.596 27.3306 12.6337C27.7783 12.9794 27.9648 13.5534 27.8058 14.0961C27.6575 14.602 27.657 15.1253 27.7937 15.6155L5.55432 15.6152C4.41688 15.6152 3.49161 16.5405 3.49161 17.6779V22.4595L1.23868 27.7344C0.865627 28.5396 1.52435 29.5365 2.41118 29.51H3.82126V43.7818C2.67866 43.9516 1.79915 44.9389 1.79915 46.1279C1.79915 47.4359 2.86327 48.5001 4.17125 48.5001H37.0742C38.3822 48.5001 39.4464 47.4359 39.4464 46.1279C39.4464 44.9387 38.5667 43.9514 37.424 43.7817V33.5037C37.424 33.1153 37.1092 32.8005 36.7209 32.8005C36.3325 32.8005 36.0177 33.1153 36.0177 33.5037V43.7557H15.2709V42.4819H33.2125C34.0566 42.4819 34.7435 41.7951 34.7435 40.951V32.3152C34.7435 32.1819 34.7246 32.0534 34.6925 31.9301C34.7222 31.9135 36.566 30.7677 36.566 30.7677L38.3496 31.8786C39.6414 32.7489 41.5311 31.699 41.476 30.1429V18.6199C41.4855 18.5956 41.4956 18.5717 41.5044 18.547C41.6948 18.0143 42.1831 17.6595 42.7485 17.6431C44.5098 17.6401 45.8671 15.7718 45.3256 14.0959C45.1666 13.5532 45.3531 12.9792 45.8008 12.6335C47.224 11.5959 47.2239 9.28675 45.8009 8.24916ZM28.3665 22.5653V17.0217H28.7134C29.5403 17.8989 31.266 17.2527 31.6543 18.6172V22.5655C31.6543 23.4717 30.9165 24.209 30.0098 24.209C29.1043 24.209 28.3677 23.4729 28.3664 22.5678L28.3665 22.5653ZM23.6728 17.0215H26.96V22.5655L26.9601 22.5677C26.9588 23.4729 26.2221 24.209 25.3166 24.209C24.4103 24.209 23.6729 23.4716 23.6729 22.5653L23.6728 17.0215ZM22.2665 22.5653C22.2665 23.4716 21.5291 24.209 20.6227 24.209C19.7164 24.209 18.979 23.4716 18.979 22.5653V17.0215H22.2664L22.2665 22.5653ZM17.5728 22.5653C17.5728 23.4716 16.8354 24.209 15.9291 24.209C15.0227 24.209 14.2854 23.4716 14.2854 22.5653V17.0215H17.5728V22.5653ZM12.879 22.5653C12.879 23.4716 12.1417 24.209 11.2353 24.209C10.329 24.209 9.59161 23.4716 9.59161 22.5653V17.0215H12.8789L12.879 22.5653ZM4.89794 17.6778C4.89794 17.3159 5.19243 17.0215 5.55432 17.0215H8.18528V22.5653C8.18528 23.4716 7.44789 24.209 6.54156 24.209C5.63523 24.209 4.89794 23.4716 4.89794 22.5653V17.6778ZM4.16206 24.4701C4.72149 25.1676 5.58001 25.6153 6.54156 25.6153C7.48436 25.6153 8.32854 25.1852 8.88844 24.511C9.44835 25.1852 10.2925 25.6153 11.2353 25.6153C12.1781 25.6153 13.0223 25.1852 13.5822 24.511C14.1421 25.1852 14.9863 25.6153 15.9291 25.6153C16.8719 25.6153 17.716 25.1852 18.276 24.511C18.8359 25.1852 19.68 25.6153 20.6228 25.6153C21.5656 25.6153 22.4098 25.1852 22.9697 24.511C23.5296 25.1852 24.3738 25.6153 25.3166 25.6153C26.2593 25.6153 27.1034 25.1853 27.6633 24.5112C28.2232 25.1853 29.0672 25.6153 30.0099 25.6153C30.6156 25.6153 31.1801 25.4372 31.6553 25.1316V28.1036H2.61013L4.16206 24.4701ZM38.0401 46.1278C38.0401 46.6605 37.6068 47.0937 37.0742 47.0937H4.17125C3.63872 47.0937 3.20547 46.6605 3.20547 46.1278C3.20547 45.5952 3.63872 45.162 4.17125 45.162H37.0742C37.6068 45.162 38.0401 45.5953 38.0401 46.1278ZM7.90795 43.7556V42.3638C7.92126 41.4512 6.48822 41.4517 6.50162 42.3638V43.7556H5.22758V29.5099H31.6553C31.659 29.886 31.6227 30.4333 31.7563 30.784L8.03293 30.7837C7.18857 30.7837 6.50162 31.4706 6.50162 32.315V39.0701C6.48831 39.9827 7.92136 39.9823 7.90795 39.0701V32.3169L7.90804 32.3151C7.90804 32.2464 7.96402 32.1904 8.03274 32.1904H13.7274C13.8485 32.1904 13.8646 32.2493 13.8646 32.3308V41.7714C13.8646 41.7738 13.8642 41.7762 13.8642 41.7786C13.8642 41.7811 13.8646 41.7834 13.8646 41.7858V43.7556H7.90795ZM33.3372 40.9509C33.3372 41.0195 33.2813 41.0755 33.2126 41.0755H15.2709V32.5183C15.2709 32.4061 15.2593 32.2967 15.2389 32.1904H33.2125C33.2812 32.1904 33.3372 32.2464 33.3372 32.3151L33.3372 40.9509ZM34.0378 30.6851C33.5446 30.9311 33.1137 30.6921 33.0615 30.1428V20.1236C33.9708 20.5544 35.0463 20.4439 35.8625 19.8606V29.549L34.0378 30.6851ZM39.7407 30.7014C39.6419 30.7561 39.3812 30.8642 39.0933 30.6849L37.2689 29.5485V19.8606C38.0883 20.4461 39.1643 20.5528 40.0698 20.1236V30.1428C40.0698 30.4821 39.8397 30.6464 39.7407 30.7014ZM44.9415 11.5205C44.0319 12.2226 43.6529 13.3888 43.9761 14.4915C44.2427 15.3163 43.5745 16.236 42.7077 16.2374C41.5591 16.2708 40.567 16.9915 40.1802 18.0737C39.911 18.8977 38.83 19.249 38.1278 18.7405C37.6533 18.4164 37.1096 18.2544 36.5657 18.2544C36.022 18.2544 35.4781 18.4165 35.0037 18.7405C34.3014 19.2488 33.2204 18.8977 32.9512 18.0737C32.5644 16.9915 31.5723 16.2708 30.4238 16.2374C29.5569 16.236 28.8888 15.3163 29.1553 14.4915C29.4785 13.3887 29.0995 12.2225 28.1899 11.5205C27.4896 11.0097 27.4896 9.873 28.1899 9.36231C29.0995 8.66018 29.4785 7.49387 29.1553 6.39112C28.8888 5.56617 29.5569 4.64671 30.4239 4.6453C31.5724 4.61183 32.5645 3.89095 32.9513 2.80902C33.2205 1.98481 34.3013 1.63379 35.0037 2.14213C35.9526 2.79036 37.1789 2.79036 38.1278 2.14213C38.8301 1.6337 39.9109 1.985 40.1802 2.80902C40.567 3.89095 41.559 4.61183 42.7077 4.6453C43.5746 4.64671 44.2427 5.56626 43.9762 6.39112C43.653 7.49396 44.032 8.66009 44.9416 9.36222C45.642 9.87309 45.6419 11.0097 44.9415 11.5205Z" fill="#5A5A5A"/>
                                        <path d="M44.9415 11.5205C44.0319 12.2226 43.6529 13.3888 43.9761 14.4915C44.2427 15.3163 43.5745 16.236 42.7077 16.2374C41.5591 16.2708 40.567 16.9915 40.1802 18.0737C39.911 18.8977 38.83 19.249 38.1278 18.7405C37.6533 18.4164 37.1096 18.2544 36.5657 18.2544C36.022 18.2544 35.4781 18.4165 35.0037 18.7405C34.3014 19.2488 33.2204 18.8977 32.9512 18.0737C32.5644 16.9915 31.5723 16.2708 30.4238 16.2374C29.5569 16.236 28.8888 15.3163 29.1553 14.4915C29.4785 13.3887 29.0995 12.2225 28.1899 11.5205C27.4896 11.0097 27.4896 9.873 28.1899 9.36231C29.0995 8.66018 29.4785 7.49387 29.1553 6.39112C28.8888 5.56617 29.5569 4.64671 30.4239 4.6453C31.5724 4.61183 32.5645 3.89095 32.9513 2.80902C33.2205 1.98481 34.3013 1.63379 35.0037 2.14213C35.9526 2.79036 37.1789 2.79036 38.1278 2.14213C38.8301 1.6337 39.9109 1.985 40.1802 2.80902C40.567 3.89095 41.559 4.61183 42.7077 4.6453C43.5746 4.64671 44.2427 5.56626 43.9762 6.39112C43.653 7.49396 44.032 8.66009 44.9416 9.36222C45.642 9.87309 45.6419 11.0097 44.9415 11.5205Z" fill="#BEBAD5"/>
                                        <path d="M40.2343 8.3533L38.6591 7.88902L37.7308 6.53454C37.2096 5.72534 35.9219 5.72562 35.4007 6.53445L34.4723 7.88902L32.8971 8.3533C31.9667 8.59903 31.5688 9.82375 32.1771 10.5694L33.1786 11.871L33.1334 13.5126C33.0786 14.4735 34.1241 15.2307 35.0184 14.8821L36.5657 14.332L38.1129 14.8821C39.0101 15.2304 40.0519 14.4733 39.9981 13.5126L39.953 11.871L40.9544 10.5695C41.5626 9.82366 41.1647 8.59922 40.2343 8.3533ZM38.6859 11.2116C38.5872 11.3398 38.5359 11.498 38.5403 11.6597L38.5923 13.5513L36.8013 12.9232C36.6489 12.869 36.4825 12.869 36.3302 12.9232L34.5392 13.5513L34.5912 11.6597C34.5956 11.4979 34.5442 11.3398 34.4456 11.2116L33.2948 9.70234L35.1098 9.16737C35.2649 9.12162 35.3996 9.02383 35.491 8.89042L36.5627 7.32958C36.5657 7.32968 37.6405 8.89042 37.6405 8.89042C37.7319 9.02383 37.8665 9.12162 38.0217 9.16737L39.8367 9.70234L38.6859 11.2116Z" fill="#5A5A5A"/>
                                        <path d="M38.6859 11.2116C38.5872 11.3398 38.5359 11.498 38.5403 11.6597L38.5923 13.5513L36.8013 12.9232C36.6489 12.869 36.4825 12.869 36.3302 12.9232L34.5392 13.5513L34.5912 11.6597C34.5956 11.4979 34.5442 11.3398 34.4456 11.2116L33.2948 9.70234L35.1098 9.16737C35.2649 9.12162 35.3996 9.02383 35.491 8.89042L36.5627 7.32958C36.5657 7.32968 37.6405 8.89042 37.6405 8.89042C37.7319 9.02383 37.8665 9.12162 38.0217 9.16737L39.8367 9.70234L38.6859 11.2116Z" fill="#FBBC05"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_15244_32144">
                                        <rect width="48" height="48" fill="white" transform="translate(0 0.5)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class="content-link-text-box">
                                    <h6>{{ __("FRANQUIA NACIONAL") }}</h6>
                                    <h5>{{ __("Seja um franqueado no Brasil") }}</h5>
                                </div>
                                <div class="content-link-arrow-box">
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="0.5" width="24" height="24" rx="12" fill="#D90F17"/>
                                        <path d="M9.9233 8.5376C9.54534 8.53766 9.23893 8.84419 9.23887 9.22203C9.23887 9.60019 9.54527 9.90659 9.9235 9.90653L13.6431 9.90646L8.25791 15.2927C7.99068 15.56 7.99068 15.9933 8.2581 16.2607C8.52546 16.528 8.95867 16.5279 9.22596 16.2606L14.6113 10.8742L14.6112 14.5946C14.6112 14.9727 14.9177 15.2792 15.2957 15.2791C15.4847 15.2791 15.6559 15.2025 15.7798 15.0786C15.9036 14.9548 15.9801 14.7836 15.9803 14.5947L15.9803 9.2219C15.9804 9.04037 15.9083 8.86633 15.7799 8.73791C15.6514 8.60955 15.4774 8.53753 15.2957 8.5374L9.9233 8.5376Z" fill="white"/>
                                    </svg>
                                </div>
                            </a>
                            <a href="https://franquicia.apolar.com.py/" target="_blank" class="content-link-item">
                                <div class="content-link-icon-box">
                                    <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M25.0095 24.6244C27.2548 24.6244 29.3696 23.9097 31.1253 22.5574C31.4386 22.3162 31.4912 21.8739 31.2429 21.5697C30.9946 21.2654 30.5392 21.2141 30.2261 21.4555C28.7287 22.6086 26.9249 23.2182 25.0095 23.2182C20.3754 23.2182 16.6054 19.556 16.6054 15.0544C16.6054 10.5528 20.3754 6.89062 25.0095 6.89062C29.6435 6.89062 33.4136 10.5529 33.4136 15.0544C33.4136 16.7793 32.8668 18.4281 31.8322 19.8223C31.5984 20.1373 31.6718 20.5768 31.996 20.8039C32.3205 21.031 32.7728 20.9597 33.0065 20.6447C34.2198 19.0094 34.8612 17.0764 34.8612 15.0544C34.8612 9.77744 30.4418 5.48438 25.0095 5.48438C19.5772 5.48438 15.1577 9.77744 15.1577 15.0544C15.1577 20.3314 19.5772 24.6244 25.0095 24.6244Z" fill="#5A5A5A"/>
                                        <path d="M30.2261 21.4555C30.5392 21.2141 30.9946 21.2654 31.2429 21.5697L31.996 20.8039C31.6718 20.5768 31.5984 20.1373 31.8322 19.8223C32.8668 18.4281 33.4136 16.7793 33.4136 15.0544C33.4136 10.5529 29.6435 6.89062 25.0095 6.89062C20.3754 6.89062 16.6054 10.5528 16.6054 15.0544C16.6054 19.556 20.3754 23.2182 25.0095 23.2182C26.9249 23.2182 28.7287 22.6086 30.2261 21.4555Z" fill="#FBBC05"/>
                                        <path d="M24.9734 16.7282C24.5152 16.7314 24.406 16.7147 24.0718 16.5023C23.7372 16.2898 23.2886 16.3808 23.0699 16.7059C22.851 17.0309 22.9448 17.4666 23.2794 17.6792C23.646 17.9121 23.938 18.0298 24.2544 18.0866V18.7502C24.2544 19.1386 24.5784 19.4533 24.9782 19.4533C25.378 19.4533 25.702 19.1386 25.702 18.7502V18.0067C26.3888 17.7591 26.9111 17.1721 27.0387 16.4352C27.1982 15.513 26.6846 14.6801 25.7605 14.3629C25.3435 14.2197 24.8312 14.0297 24.5695 13.8304C24.5537 13.8145 24.5278 13.7303 24.5583 13.6162C24.5744 13.556 24.6283 13.4112 24.7805 13.3668C25.27 13.2239 25.7788 13.5536 25.7991 13.5672C26.1226 13.7903 26.5719 13.719 26.805 13.4057C27.0391 13.091 26.9662 12.6515 26.6422 12.424C26.5787 12.3794 26.2191 12.1386 25.7021 12.0079V11.3564C25.7021 10.968 25.3781 10.6533 24.9783 10.6533C24.5785 10.6533 24.2545 10.968 24.2545 11.3564V12.0561C23.6756 12.267 23.2491 12.7666 23.1292 13.3847C23.0108 13.9948 23.2203 14.5895 23.6758 14.9364C24.1 15.2595 24.6966 15.4889 25.2781 15.6886C25.5423 15.7793 25.6544 15.952 25.6111 16.202C25.5775 16.3961 25.4053 16.7254 24.9734 16.7282Z" fill="#5A5A5A"/>
                                        <path d="M20.4133 10.5922C20.1008 10.3497 19.6454 10.3992 19.396 10.7026C18.3849 11.932 17.8281 13.4773 17.8281 15.0539C17.8281 18.9004 21.0496 22.0297 25.0093 22.0297C28.9689 22.0297 32.1904 18.9004 32.1904 15.0539C32.1904 11.2075 28.9689 8.07812 25.0093 8.07812C23.8009 8.07812 22.6055 8.3755 21.5525 8.93818C21.2022 9.12531 21.0745 9.5529 21.2671 9.89311C21.4597 10.2334 21.8997 10.3576 22.2502 10.1703C23.09 9.72164 24.0442 9.48446 25.0094 9.48446C28.1709 9.48446 30.7429 11.9829 30.7429 15.054C30.7429 18.1252 28.1709 20.6236 25.0094 20.6236C21.8478 20.6236 19.2759 18.1252 19.2759 15.054C19.2759 13.777 19.7085 12.5758 20.5271 11.5805C20.7765 11.2769 20.7256 10.8345 20.4133 10.5922Z" fill="#5A5A5A"/>
                                        <path d="M24.9782 4.41394C25.378 4.41394 25.702 4.09923 25.702 3.71082V1.20312C25.702 0.814717 25.378 0.5 24.9782 0.5C24.5784 0.5 24.2544 0.814717 24.2544 1.20312V3.71082C24.2544 4.09923 24.5785 4.41394 24.9782 4.41394Z" fill="#5A5A5A"/>
                                        <path d="M20.7961 5.16412C21.1959 5.16412 21.5199 4.84941 21.5199 4.461V1.20312C21.5199 0.814717 21.1959 0.5 20.7961 0.5C20.3962 0.5 20.0723 0.814717 20.0723 1.20312V4.461C20.0723 4.84941 20.3963 5.16412 20.7961 5.16412Z" fill="#5A5A5A"/>
                                        <path d="M29.2228 5.16412C29.6227 5.16412 29.9467 4.84941 29.9467 4.461V1.20312C29.9467 0.814717 29.6227 0.5 29.2228 0.5C28.823 0.5 28.499 0.814717 28.499 1.20312V4.461C28.499 4.84941 28.823 5.16412 29.2228 5.16412Z" fill="#5A5A5A"/>
                                        <path d="M17.2038 7.43698C17.6036 7.43698 17.9276 7.12227 17.9276 6.73386V1.20312C17.9276 0.814717 17.6036 0.5 17.2038 0.5C16.804 0.5 16.48 0.814717 16.48 1.20312V6.73386C16.48 7.12227 16.804 7.43698 17.2038 7.43698Z" fill="#5A5A5A"/>
                                        <path d="M32.8151 7.43698C33.215 7.43698 33.5389 7.12227 33.5389 6.73386V1.20312C33.5389 0.814717 33.215 0.5 32.8151 0.5C32.4153 0.5 32.0913 0.814717 32.0913 1.20312V6.73386C32.0913 7.12227 32.4154 7.43698 32.8151 7.43698Z" fill="#5A5A5A"/>
                                        <path d="M47.5613 26.2285L46.9747 25.6595C46.3285 25.0318 45.4706 24.6865 44.5577 24.6865C44.5534 24.6865 44.5491 24.6866 44.5448 24.6866C43.6272 24.6898 42.7671 25.0414 42.1228 25.6764L36.6155 31.1052C36.523 31.1969 36.3934 31.2494 36.26 31.2494H33.2292C33.2836 31.0107 33.3125 30.7649 33.3125 30.5145C33.3125 28.6578 31.7576 27.1473 29.8461 27.1473H24.1778C23.864 27.1473 23.5603 27.0205 23.3225 26.7902C22.1577 25.6627 20.4017 25.0161 18.5049 25.0161C15.7562 25.0161 13.9404 26.5607 13.1027 27.4813C13.0945 27.4903 13.0866 27.4994 13.0789 27.5088L8.99867 32.4835C8.15035 31.6816 6.78948 31.6873 5.94985 32.5029L4.90244 33.5204L4.89114 33.5093C4.57208 33.1994 4.14802 33.0288 3.69694 33.0288C3.24576 33.0288 2.8217 33.1994 2.50283 33.5093L0.493705 35.4609C-0.164584 36.1005 -0.164584 37.1412 0.493801 37.781L2.0087 39.2525C2.29128 39.527 2.74961 39.527 3.03238 39.2524C3.31505 38.9778 3.31505 38.5326 3.03228 38.2581L1.51747 36.7867C1.42338 36.6953 1.42338 36.5465 1.51738 36.4553L3.5265 34.5037C3.58798 34.444 3.65969 34.4351 3.69704 34.4351C3.73429 34.4351 3.80609 34.444 3.86757 34.5038L14.4077 44.7423C14.5018 44.8337 14.5018 44.9825 14.4078 45.0737L12.3987 47.0252C12.3372 47.085 12.2654 47.0938 12.2282 47.0938C12.1908 47.0938 12.1191 47.0849 12.0576 47.0252L5.2628 40.4248C4.98003 40.1504 4.5218 40.1502 4.23913 40.4248C3.95645 40.6995 3.95645 41.1446 4.23913 41.4192L11.034 48.0195C11.3529 48.3295 11.777 48.5001 12.2282 48.5001C12.6792 48.5001 13.1033 48.3295 13.4223 48.0196L15.4314 46.068C16.0897 45.4284 16.0897 44.3877 15.4314 43.7479L15.42 43.7369L16.4674 42.7194C17.1141 42.0912 17.2652 41.1624 16.9237 40.3921L25.4448 40.8205C25.5035 40.8234 25.5621 40.8248 25.6206 40.8248C25.9553 40.8248 26.2849 40.7778 26.6015 40.6848L38.5675 37.2012C39.0199 37.0686 39.4285 36.8208 39.75 36.4841L47.6013 28.2403C48.1477 27.6663 48.1307 26.7832 47.5613 26.2285ZM15.4436 41.7249L14.3961 42.7424L5.92611 34.5146L6.97352 33.4972C7.25581 33.2232 7.715 33.223 7.997 33.4972L15.4436 40.7308C15.7257 41.0049 15.7257 41.4509 15.4436 41.7249ZM46.5386 27.2853L38.688 35.5285C38.5418 35.6815 38.3555 35.7945 38.1505 35.8546L26.184 39.3381C25.9701 39.401 25.7454 39.4269 25.5185 39.416L15.6254 38.9185L10.0298 33.4829L14.1993 28.3994C14.8808 27.6547 16.3365 26.4223 18.5048 26.4223C19.9992 26.4223 21.4182 26.9322 22.3003 27.786C22.8113 28.2809 23.478 28.5535 24.1777 28.5535H29.846C30.9591 28.5535 31.8648 29.4332 31.8648 30.5145C31.8648 31.0385 31.6547 31.5316 31.2743 31.9018C30.8922 32.2723 30.3849 32.4764 29.846 32.4764H21.6229C21.2231 32.4764 20.8991 32.7912 20.8991 33.1796C20.8991 33.568 21.2231 33.8827 21.6229 33.8827H29.846C30.771 33.8827 31.6415 33.5327 32.2979 32.8962C32.3772 32.819 32.452 32.7386 32.5226 32.6555H36.2599C36.7796 32.6555 37.2859 32.4493 37.6477 32.0909L43.1538 26.6634C43.5253 26.2973 44.0211 26.0946 44.55 26.0928C44.5524 26.0927 44.555 26.0927 44.5575 26.0927C45.0836 26.0927 45.5783 26.2918 45.9512 26.6541L46.5372 27.2224C46.5548 27.2395 46.5553 27.2676 46.5386 27.2853Z" fill="#5A5A5A"/>
                                    </svg>
                                </div>
                                <div class="content-link-text-box">
                                    <h6>{{ __("FRANQUIA INTERNACIONAL") }}</h6>
                                    <h5>{{ __("Expanda seu negócio para o Paraguai") }}</h5>
                                </div>
                                <div class="content-link-arrow-box">
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="0.5" width="24" height="24" rx="12" fill="#D90F17"/>
                                        <path d="M9.9233 8.5376C9.54534 8.53766 9.23893 8.84419 9.23887 9.22203C9.23887 9.60019 9.54527 9.90659 9.9235 9.90653L13.6431 9.90646L8.25791 15.2927C7.99068 15.56 7.99068 15.9933 8.2581 16.2607C8.52546 16.528 8.95867 16.5279 9.22596 16.2606L14.6113 10.8742L14.6112 14.5946C14.6112 14.9727 14.9177 15.2792 15.2957 15.2791C15.4847 15.2791 15.6559 15.2025 15.7798 15.0786C15.9036 14.9548 15.9801 14.7836 15.9803 14.5947L15.9803 9.2219C15.9804 9.04037 15.9083 8.86633 15.7799 8.73791C15.6514 8.60955 15.4774 8.53753 15.2957 8.5374L9.9233 8.5376Z" fill="white"/>
                                    </svg>
                                </div>
                            </a>
                            <!-- <a href="#" class="content-link-item">
                                <div class="content-link-icon-box">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
                                        <g clip-path="url(#clip0_15244_32174)">
                                            <path d="M47.7494 10.8968C47.7376 16.0844 43.4488 20.25 38.2612 20.25H30.7667C30.5875 20.25 30.5126 20.0211 30.657 19.9151L32.5827 18.5029C32.668 18.4403 32.6686 18.3143 32.5854 18.2489C30.4193 16.5463 29.0217 13.9095 28.9997 10.9459C28.9615 5.77322 33.1876 1.50759 38.3605 1.5C43.552 1.49241 47.7612 5.70431 47.7494 10.8968Z" fill="#FFF3C2"/>
                                            <mask id="mask0_15244_32174" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="-1" y="0" width="49" height="49">
                                            <path d="M-0.000537872 0.500004H47.9995V48.5H-0.000537872V0.500004Z" fill="white"/>
                                            </mask>
                                            <g mask="url(#mask0_15244_32174)">
                                            <path d="M41.8631 44.9844H45.8908C46.6674 44.9844 47.297 45.614 47.297 46.3906C47.297 47.1673 46.6674 47.7969 45.8908 47.7969H2.10951C1.33289 47.7969 0.703262 47.1673 0.703262 46.3906C0.703262 45.614 1.33289 44.9844 2.10951 44.9844H38.5747" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7.59389 26.4902V18.8748H13.2189V22.1489" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M13.7814 18.875H7.03139C6.82429 18.875 6.65639 18.7071 6.65639 18.5V16.4375C6.65639 16.2304 6.82429 16.0625 7.03139 16.0625H13.7814C13.9885 16.0625 14.1564 16.2304 14.1564 16.4375V18.5C14.1564 18.7071 13.9885 18.875 13.7814 18.875Z" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M33.9376 31.7115V44.9844H5.81264V31.7115" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M11.2627 27.3509L19.8751 20.7414L35.1439 32.4593C35.3993 32.6552 35.7003 32.75 35.999 32.75C36.4211 32.7499 36.8388 32.5605 37.1157 32.1998C37.5885 31.5837 37.4723 30.7009 36.8562 30.228L20.7313 17.853C20.2263 17.4657 19.524 17.4657 19.019 17.853L2.89407 30.228C2.27795 30.7009 2.16179 31.5837 2.63457 32.1998C3.10745 32.8158 3.9902 32.932 4.60632 32.4593L8.65998 29.3483" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M18.2807 44.9844H9.84321V34.0228H18.2807V44.9844Z" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M15.9376 40.7188V39.9688" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M23.1564 27.875C23.1564 29.6872 21.6873 31.1562 19.8751 31.1562C18.0629 31.1562 16.5939 29.6872 16.5939 27.875C16.5939 26.0628 18.0629 24.5938 19.8751 24.5938C21.6873 24.5938 23.1564 26.0628 23.1564 27.875Z" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M16.6876 27.918H23.0626" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M19.8751 24.7305V31.1055" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M29.9057 39.6475H21.6557V34.0225H29.9057V39.6475Z" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M25.7814 34.2607V39.6133" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M45.9299 5.7006C46.8008 7.12738 47.301 8.80503 47.297 10.5999C47.2852 15.7876 42.9964 19.9531 37.8087 19.9531H30.3143C30.135 19.9531 30.0601 19.7242 30.2046 19.6183L32.1302 18.2061C32.2155 18.1435 32.2162 18.0175 32.1329 17.9521C29.9668 16.2494 28.5692 13.6127 28.5473 10.649C28.509 5.47635 32.7352 1.21072 37.908 1.20313C40.1255 1.19994 42.1637 1.96644 43.7704 3.25053" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M40.1401 6.73921C39.3385 5.97983 38.6776 5.2064 37.0621 5.80686C35.5435 6.37124 35.1256 8.39661 36.1798 9.22339C36.7851 9.69814 37.6958 10.0885 38.9233 10.5224C41.6704 11.4935 40.6549 15.3677 37.8605 15.3862C36.7699 15.3936 36.2601 15.3244 35.3021 14.6976" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M37.8599 4.35613V16.8008" stroke="#5A5A5A" stroke-width="1.40625" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_15244_32174">
                                            <rect width="48" height="48" fill="white" transform="translate(0 0.5)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                                <div class="content-link-text-box">
                                    <h6>{{ __("BLOG INVESTIMENTOS Apolar") }}</h6>
                                    <h5>{{ __("Posts sobre investimentos imobiliários") }}</h5>
                                </div>
                                <div class="content-link-arrow-box">
                                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect y="0.5" width="24" height="24" rx="12" fill="#D90F17"/>
                                        <path d="M9.9233 8.5376C9.54534 8.53766 9.23893 8.84419 9.23887 9.22203C9.23887 9.60019 9.54527 9.90659 9.9235 9.90653L13.6431 9.90646L8.25791 15.2927C7.99068 15.56 7.99068 15.9933 8.2581 16.2607C8.52546 16.528 8.95867 16.5279 9.22596 16.2606L14.6113 10.8742L14.6112 14.5946C14.6112 14.9727 14.9177 15.2792 15.2957 15.2791C15.4847 15.2791 15.6559 15.2025 15.7798 15.0786C15.9036 14.9548 15.9801 14.7836 15.9803 14.5947L15.9803 9.2219C15.9804 9.04037 15.9083 8.86633 15.7799 8.73791C15.6514 8.60955 15.4774 8.53753 15.2957 8.5374L9.9233 8.5376Z" fill="white"/>
                                    </svg>
                                </div>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div v-if="!checkIsMobile && !onlysearch" class="col-md-7 pl-0">
                <h1>{{ __("A mais completa imobiliária de Curitiba no Paraná e Santa Catarina") }}</h1>

                <a v-if="search_banners.link" :href="search_banners.link" target="_blank">
                    <img :alt="search_banners.alt" width="1" height="1" class="home-banner" :src="search_banners.image"/>
                </a>

                <img v-if="!search_banners.link" :alt="search_banners.alt" width="1" height="1" class="home-banner" :src="search_banners.image"/>

            </div> -->
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import "@/assets/scss/custom/principal/components/_home_search.scss"
import jQuery from "jquery";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import {VMoney} from 'v-money'
import VSelectInfinite from "../VSelectInfinite.vue"
import VSelectMultipleVue from '../VSelectMultiple.vue';

import PropertiesService from "../../../../services/PropertiesService";


export default {
  directives: {money: VMoney},
  components: {
    vSelect,
    VSelectInfinite,
    VSelectMultipleVue
  },
  props: {
    onlysearch: {
      type: Boolean,
      default() {
        return false
      }
    },
    openAdvanced: {
        type: Boolean,
        default() {
            return true
        }
    },
    clearFilterOnOpen: {
        type: Boolean,
        default() {
            return false
        }
    },
  },
  data() {
    return {
        filters: {
            business: "Vendas", //ok
            business_subfilter: "Residencial", //ok
            reference: null, //ok
            city: null, //ok
            district: [], //ok
            property_type: [], //ok
            property_type_combo: [], // ok
            bedrooms: [], //ok
            garage: [], //ok
            price_max: null, //ok
            price_min: null, //ok
            address: null, //ok
            address_number: null,
            open_search: '',//ok
            in_condominium: false // ok
        },
        filters_options: {
            sub_filters: {
                "Vendas":[
                        {
                            "id":"",
                            "label": "Residencial",
                            "types": [
                                {"id":"Apartamento", "label":"Apartamento", "img": require("@/assets/img/home/apartamento.webp"), "size": "63x63"},
                                {"id":"Casa|Sobrado", "label":"Casa e sobrado", "img": require("@/assets/img/home/casa-sobrado.webp"), "size": "53x53"},
                                {"id":"Studio|Kitnet", "label":"Studio e kitnet", "img": require("@/assets/img/home/studio.webp"), "size": "63x63"},
                                {"id":"Terreno", "label":"Terreno", "img": require("@/assets/img/home/terreno.webp"), "size": "51x51"}
                            ]
                        },
                        {
                            "id":"",
                            "label": "Comercial",
                            "types": [
                                {"id":"Sala", "label":"Sala", "img": require("@/assets/img/home/sala-predio.webp"), "size": "62x63"},
                                {"id":"Loja", "label":"Loja", "img": require("@/assets/img/home/loja.webp"), "size": "56x56"},
                                {"id":"Casa|Sobrado", "label":"Casa comercial", "img": require("@/assets/img/home/casa-comercial.webp"), "size":"61x60"},
                                {"id":"Barracão", "label":"Barracão", "img": require("@/assets/img/home/barracao.webp"), "size": "56x56"}
                            ]
                        },
                        {
                            "id":"",
                            "label": "Lançamentos",
                            "types": [
                                {"id":"Apartamento", "label":"Apartamento", "img": require("@/assets/img/home/apartamento.webp"), "size": "63x63"},
                                {"id":"Casa|Sobrado", "label":"Casa e sobrado", "img": require("@/assets/img/home/casa-sobrado.webp"), "size": "53x53"},
                                {"id":"Studio", "label":"Studio", "img": require("@/assets/img/home/studio.webp"), "size": "63x63"},
                                {"id":"Comercial", "label":"Comercial", "img": require("@/assets/img/home/loja.webp"), "size": "56x56"}
                            ]
                        },
                        {
                            "id":"",
                            "label": "Triple A",
                            "types": [
                                {"id":"Apartamento", "label":"Apartamento", "img": require("@/assets/img/home/apartamento.webp"), "size": "63x63"},
                                {"id":"Casa|Sobrado", "label":"Casa e sobrado", "img": require("@/assets/img/home/casa-sobrado.webp"), "size": "53x53"},
                                {"id":"Studio", "label":"Studio", "img": require("@/assets/img/home/studio.webp"), "size": "63x63"},
                                {"id":"Comercial", "label":"Comercial", "img": require("@/assets/img/home/loja.webp"), "size": "56x56"}
                            ]
                        }
                ],
                "Locacao":[
                    {
                        "id":"",
                        "label": "Mensal",
                        "types": [
                            {"id":"Apartamento", "label":"Apartamento", "img": require("@/assets/img/home/apartamento.webp"), "size": "63x63"},
                            {"id":"Casa|Sobrado", "label":"Casa e sobrado", "img": require("@/assets/img/home/casa-sobrado.webp"), "size": "53x53"},
                            {"id":"Studio|Kitnet", "label":"Studio e kitnet", "img": require("@/assets/img/home/studio.webp"), "size": "63x63"},
                            {"id":"Terreno", "label":"Terreno", "img": require("@/assets/img/home/terreno.webp"), "size": "51x51"}
                        ]
                    },
                    {
                        "id":"",
                        "label": "Comercial",
                        "types": [
                            {"id":"Sala", "label":"Sala", "img": require("@/assets/img/home/sala-predio.webp"), "size": "62x63"},
                            {"id":"Loja", "label":"Loja", "img": require("@/assets/img/home/loja.webp"), "size": "56x56"},
                            {"id":"Casa|Sobrado", "label":"Casa comercial", "img": require("@/assets/img/home/casa-comercial.webp"), "size":"61x60"},
                            {"id":"Barracão", "label":"Barracão", "img": require("@/assets/img/home/barracao.webp"), "size": "56x56"}
                        ]
                    },
                    {
                        "id":"",
                        "label": "Temporário",
                        "types": [
                            {"id":"Apartamento", "label":"Apartamento", "img": require("@/assets/img/home/apartamento.webp"), "size": "63x63"},
                            {"id":"Studio", "label":"Studio", "img": require("@/assets/img/home/studio.webp"), "size": "63x63"},
                            {"id":"Casa|Sobrado", "label":"Casa e sobrado", "img": require("@/assets/img/home/casa-sobrado.webp"), "size": "53x53"},
                            {"id":"Outros", "label":"Outros imóveis", "img": require("@/assets/img/home/terreno.webp"), "size": "51x51"}
                        ]
                    },
                ]
            },
            cities: [],
            types: [],
            references: [],
            adresses: [],
            open_search: []
        },
        show_other_types: false,
        use_advanced_filters: false,
        filter_by_ref: false,
        moneyMask: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
        old_site_url: "https://www.apolar.com.br",
        blacknovember: false,
        showFranchiseeRegister: false,
    };
  },
  computed: {
      
      search_banners() {

        if ( this.blacknovember && this.lang != 'es' ) {
            return {
                "image": require("@/assets/img/home/banners/blacknovember.webp"),
                "alt": "Black November - Imóveis com Descontos Especiais",
                "link": "https://www.apolar.com.br/feirao-apolar"
            }
        }


        switch (this.filters.business_subfilter) {
            case "Comercial":
                return {
                    "image": require("@/assets/img/home/banners/comercial.webp"),
                    "alt": "Mulher jovem e feliz no trabalho em um imóvel comercial"
                }
                break;
            
            case "Lançamentos":
            case "Temporário":
                return {
                    "image": require("@/assets/img/home/banners/lancamento_temporario.webp"),
                    "alt": "Pai jovem e feliz brincando com seu filho no chão de seu apartamento novo"
                }
                break;

            case "Residencial":
            case "Mensal":
                if (this.lang == 'es') {
                    return {
                        "image": require("@/assets/img/home/banners/residencial_mensal_py.webp"),
                        "alt": "Familia feliz en su nuevo inmueble o casa en Asunción"
                    }
                }
                return {
                    "image": require("@/assets/img/home/banners/residencial_mensal.webp"),
                    "alt": "Casal jovem brincando com o cachorro durante o café da manhã na sala de estar de seu novo imóvel"
                }
                break;

            case "Triple A":
                return {
                    "image": require("@/assets/img/home/banners/triplea.webp"),
                    "alt": "Pai feliz sentado em seu sofá confortável, brincando com suas filhas em uma sala de estar moderna e sofisticada."
                }
                break;
        
            default:
                return {
                    "image": require("@/assets/img/home/banners/home-search-bg.webp"),
                    "alt": "Família feliz com cachorro em nova casa"
                }
                break;
        }
      },
      citiesOptions() {
          return this.filters_options.cities.map(item=>{return item.city})
      },
      districtOptions() {
        //this.filters.district = []
        if (this.filters.city == null || this.filters.city == ""){
            return []
        }

        let districts = this.filters_options.cities.filter(item => item.city == this.filters.city)[0].districts.sort(function (a, b) {
            return a.localeCompare(b);
        })

        //to remove register duplicated and wrong
        districts.forEach((district, key) => {
            let district_sanitized = district.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')

            let exists = districts.indexOf(district_sanitized)
            if ( exists != -1 && district_sanitized != district  ) {
                delete districts[exists]
            }
        })
        
        return districts.sort(function (a, b) {
            return a.localeCompare(b);
        });

      },

      visual_types() {
        if ( this.filters.business && this.filters.business_subfilter ) {
            let sub_filters = this.filters_options__sub_filters[this.filters.business]
            let sub_filter = sub_filters.filter(sub => sub.label == this.filters.business_subfilter)
            return sub_filter.length > 0 ? sub_filter[0]['types'] : null
        }
        return null
      }, 

      property_type_purpose() {
        let comercial_types = ['Barracão', 'Conjunto', 'Hotel', 'Loja', 'Ponto', 'Prédio', 'Sala', 'Sobreloja', 'Área', 'Casa', 'Terreno']
        if (this.filters.business_subfilter == "Comercial") {
            return comercial_types.sort(function (a, b) {
                        return a.localeCompare(b);
                })
        }

        let residencial_types = this.filters_options.types.filter(type => comercial_types.indexOf(type) == -1)
        

        if ( this.lang != 'es' ) {
            residencial_types = residencial_types.concat('Área', 'Casa', 'Terreno')
        }

        if ( this.lang == 'es' ) {
            residencial_types = residencial_types.filter(type => type != 'Flat')
        }

        return residencial_types.sort(function (a, b) {
                    return a.localeCompare(b);
            })
      },

      _business_subfilters() {
        let subfilters = this.filters_options__sub_filters[this.filters.business]

        if ( this.lang == 'es' ) {
            var ignore_subfilters = []
            if ( this.filters.business == 'Vendas' ) {
                ignore_subfilters = ['Lançamentos', 'Triple A']
            } else {
                ignore_subfilters = ['Temporário']
            }
            return subfilters.filter(sf => ignore_subfilters.indexOf(sf.label) == -1)
        }   

        return subfilters
      },

      filters_options__sub_filters() {

            let sub_filters = this.filters_options.sub_filters

            if ( this.lang == "es" ) {
                sub_filters['Vendas'][0] = {
                        "id":"",
                        "label": "Residencial",
                        "types": [
                            {"id":"Apartamento", "label":"Apartamento", "img": require("@/assets/img/home/apartamento.webp"), "size": "63x63"},
                            {"id":"Casa|Sobrado", "label":"Casa e sobrado", "img": require("@/assets/img/home/casa-sobrado.webp"), "size": "53x53"},
                            {"id":"Studio|Kitnet", "label":"Studio e kitnet", "img": require("@/assets/img/home/studio.webp"), "size": "63x63"},
                            {"id":"Terreno", "label":"Terreno", "img": require("@/assets/img/home/terreno.webp"), "size": "51x51"}
                        ]
                }
            }

            return sub_filters
        
    }
  },
  methods: {

    onSubfilterClick(subLabel) {
         this.filters.business_subfilter = subLabel;
         console.log(this.filters_options.sub_filters)
         this.emitNewBgClass(subLabel)
        this.clearFilter(true);
    },
    emitNewBgClass(subLabel){
        if(subLabel === "Residencial" || subLabel === "Mensal"){
            this.$emit("new-bg-class", "home-search-bg-residencial");
        }
        else if(subLabel === "Comercial"){
            this.$emit("new-bg-class", "home-search-bg-comercial");

        }
        else if(subLabel === "Lançamentos" || subLabel === "Temporário"){
            this.$emit("new-bg-class", "home-search-bg-lancamentos");

        }
        else if(subLabel === "Triple A"){
            this.$emit("new-bg-class", "home-search-bg-triplea");

        }

    },
    getVisualTypeClass(type) {
        let _class = `visual-type-${this.slugify(type.id)} `
        if ( type.id == "Outros" ) {
            _class += `trigger-property-types `
        }
        _class +=  `${this.filters.property_type_combo.indexOf(type.id) != -1 ? 'active' : ''}`
        return _class
    },

    clearReferenceFilter() {
        this.filters.reference = null
    },

    numeric_options(range=10, label, sufix, zero_option=false) {
        let options = [];

        if (zero_option) {
            options.push({
                "label": `0`,
                "id": 0
            })
        }

        [...Array(range).keys()].forEach((num)=>{
            let opt_num = num + 1
            let _sufix = sufix ? sufix : null
            if ( !_sufix ) {
                _sufix = opt_num >=4 ? '+':''
            }
            options.push({
                "label": `${opt_num}${_sufix}`,
                "id": opt_num
            })
        })
        return options
    },

    checkPropertyTypeHidden() {

        if ( this.use_advanced_filters ) {
            this.show_other_types = true
        } else {
            this.show_other_types = false
        }

    },

    handleOpenSearch() {
        
        let open_search = this.filters.open_search
        let check_is_reference = parseInt(open_search)

        console.log("open_search: ", open_search)

        //check se é busca por numero de referencia
        if ( !isNaN(check_is_reference) ) {
            this.filters.reference = check_is_reference
        } else {

            this.filters.reference = null
            let open_search_parts = open_search.split(',')
            
            switch (open_search_parts.length) {
                case 1:
                    Vue.set(this.filters, 'city', open_search_parts[0].trim())
                    Vue.set(this.filters, 'district', [])
                    Vue.set(this.filters, 'address', null)
                    Vue.set(this.filters, 'address_number', null)
                    break;

                case 2:
                    Vue.set(this.filters, 'city', open_search_parts[1].trim())
                    Vue.set(this.filters, 'district', [open_search_parts[0].trim()])
                    Vue.set(this.filters, 'address', null)
                    Vue.set(this.filters, 'address_number', null)
                    break;

                case 3:
                    Vue.set(this.filters, 'city', open_search_parts[2].trim())
                    //Vue.set(this.filters, 'district', [open_search_parts[1].trim()])
                    Vue.set(this.filters, 'address', open_search_parts[0].trim())
                    Vue.set(this.filters, 'address_number', null)
                    break;

                case 4:
                    Vue.set(this.filters, 'city', open_search_parts[3].trim())
                    //Vue.set(this.filters, 'district', [open_search_parts[1].trim()])
                    Vue.set(this.filters, 'address_number', open_search_parts[1].trim())
                    Vue.set(this.filters, 'address', open_search_parts[0].trim())
                    break;

                default:
                    break;
            }

        }

        this.loadExistingFilters(true)
        
    },


    //on change type by button, reflect on select field type
    handlePropertyTypeButtons(type) {
        
        if (type == "Outros") {
            this.show_other_types = !this.show_other_types
            return false
        }

        let type_index = this.filters.property_type_combo.indexOf(type)

        if ( type_index == -1 ) {
            this.filters.property_type_combo.push(type)

            this.filters.property_type_combo.forEach((propType)=>{
                let types = propType.split("|")
                types.forEach((type)=>{
                    if ( this.filters.property_type.indexOf(type) == -1 && type != 'Condominio' ) {
                        this.filters.property_type.push(type)
                    }
                })
            })

        } else {
            this.filters.property_type_combo.splice(type_index, 1)
            type.split("|").forEach((sub_type)=>{
                let sub_type_idx =  this.filters.property_type.indexOf(sub_type)
                if ( sub_type_idx != -1 ) {
                    this.filters.property_type.splice(sub_type_idx, 1)
                }
            })
        }

        this.filters.in_condominium = false
        if ( this.filters.property_type_combo.indexOf("Condominio") != -1 ) {
            this.filters.in_condominium = true
        }

    },

    //on change type by select, reflect on buttons type
    changePropertyTypeCombo() {

        let possible_types = []
        let possible_types_vendas = this.filters_options__sub_filters['Vendas'].map(item => item['types'].map(sub =>sub.id))
        let possible_types_locacao = this.filters_options__sub_filters['Locacao'].map(item => item['types'].map(sub =>sub.id))
        possible_types_vendas.forEach((list_types)=>{possible_types = possible_types.concat(list_types)})
        possible_types_locacao.forEach((list_types)=>{possible_types = possible_types.concat(list_types)})
        possible_types = possible_types.filter(type => type != 'Casa' && type != 'Studio')
        possible_types = [...new Set(possible_types)]
                                

        this.filters.property_type.forEach((type)=>{
            let possible_type_idx = possible_types.findIndex(p_type => p_type.indexOf(type) != -1)
            let possible_type = possible_types[possible_type_idx]

            if ( possible_type != -1 && this.filters.property_type_combo.indexOf(possible_type) == -1  ) {
                this.filters.property_type_combo.push(possible_type)
            }
        })

        this.filters.property_type_combo.forEach((propType, idx)=>{
            if(typeof propType != "undefined") {
                let type_changed = this.filters.property_type.findIndex(type => propType.indexOf(type) != -1)
                console.log(propType, idx, type_changed)
                if (type_changed == -1) {
                    this.filters.property_type_combo.splice(idx, 1)
                }
            }
        })
        
    },


    search() {

        //busca preparada para enviar para site atual em wordpress
        let filters = {}
        filters.filters = {}
        
        if (this.filters.reference) {
            filters.filters.referencia = this.filters.reference
        } else {

            if (this.filters.business) {
                filters.filters.finalidade = this.filters.business
            }

            if (this.filters.city) {
                filters.filters.cidade = this.filters.city ? this.filters.city.trim() : null
            }

            if (this.filters.district) {
                filters.filters.bairro = this.filters.district
            }
            
            if ( this.filters.property_type ) {
                filters.filters.tipo = this.filters.property_type
            }
            
            if ( this.filters.bedrooms ) {
                filters.filters.quartos = this.filters.bedrooms.id
            }

            if ( this.filters.garage ) {
                filters.filters.vagas = this.filters.garage.id
            }

            if ( this.filters.address ) {
                filters.filters.endereco = this.filters.address ? this.filters.address.trim() : null
            }
            
            filters.filters.preco_de = this.filters.price_min ? parseFloat(this.filters.price_min.replace('R$','').replace('.','').replace(',','.')) : 0.00
            filters.filters.preco_ate = this.filters.price_max ? parseFloat(this.filters.price_max.replace('R$','').replace('.','').replace(',','.')) : 0.00
        }


        let filter_type = this.filters.property_type && this.filters.property_type.length > 0 ? this.slugify(this.filters.property_type[0]) : null
        let purpose = this.slugify(this.filters.business_subfilter)

        if (purpose == "comercial" && filter_type == "sala") {
            filter_type = "sala-comercial"
        }
        // console.log("filter_type: ", filter_type)
        // console.log("purpose: ", purpose)
        // return false

        if ( this.filters.property_type_combo.length > 0 && !filter_type ) {
            let type_combo = this.filters.property_type_combo[0].split("|")
            filter_type = this.slugify(type_combo[0])
        }

        let bedrooms_label = 'quartos'
        if (this.filters.bedrooms && (this.filters.bedrooms.length == 1 && this.filters.bedrooms[0] <=1 )) {
            bedrooms_label = 'quarto'
        }

        let route_params = {
            transaction: this.filters.business == "Vendas" ? 'venda' : 'alugar',
            type: filter_type,
            city: this.filters.city ? this.slugify(this.filters.city) :  null,
            district: this.filters.district && this.filters.district.length > 0 ? this.slugify(this.filters.district[0]) : null,
            address: this.filters.address ? this.slugify(this.filters.address) :  null,
            bedrooms: this.filters.bedrooms && this.filters.bedrooms.length > 0 ? `${this.filters.bedrooms.join('-')}-${bedrooms_label}` :  null
        }

        let query = {}
        query[purpose]=null;

        let ignore_fields = ['business', 'business_subfilter', 'property_type_combo', 'open_search', 'city', 'bedrooms']
        let handle_float_values = ['price_min', 'price_max']

        if ( this.filters.property_type.length == 1 ) {
            ignore_fields.push('property_type')
        }

        if ( this.filters.district.length == 1 ) {
            ignore_fields.push('district')
        }

        if ( this.filters.price_min == 'R$ 0,00' ) {
            ignore_fields.push('price_min')
        }

        if ( this.filters.price_max == 'R$ 0,00' ) {
            ignore_fields.push('price_max')
        }

        Object.keys(this.filters).forEach((field) => {
            let value = this.filters[field]
            if (value && ignore_fields.indexOf(field) == -1) {
                query[field]=value;
            }
        })

        Vue.set(this, '$advanced_filters', {})
        Vue.set(this, '$advanced_filters', this.filters)

        this.$emit("filterApplied", true)        
        this.$router.push({
                name: "principal-property-search",
                query: query,
                params: route_params
        });

    },

    onTheFlyForm(url, data) {

        var new_form = jQuery('<form>', {
            'action': url,
            'method': 'POST',
            'target': '_top'
        })

        var fields_list = ['bairro', 'tipo', 'quartos', 'vagas'] 

        Object.keys(data.filters).forEach((field)=>{
            let value  = data.filters[field]


            let input_name = `filters[${field}]${ (fields_list.indexOf(field) != -1 ? '[]' : '') }`

            if ( typeof value == "object" ) {

                value.forEach((value_item)=>{
                    let input = jQuery('<input>', {
                        'name': input_name,
                        'value': value_item,
                        'type': 'hidden'
                    })

                    new_form.append(input)
                })

            } else {
                let input = jQuery('<input>', {
                    'name': input_name,
                    'value': value,
                    'type': 'hidden'
                })

                new_form.append(input)
            }
            
            
        })

        new_form.appendTo('body').submit()
    },

    prepare_send_url() {

        var business = "alugar"
        var city = ""
        var district = ""
        var property_type = ""

        if (this.filters.business == "Vendas" || this.filters.business_subfilter == "Lançamentos") {
            business = "venda"
        }

        if (this.filters.business_subfilter == "Temporário") {
            business = "temporada"
        }

        if (this.filters.business_subfilter == "Triple A") {
            business = "triplea/comprar"
        }

        if ( this.filters.city != "" && this.filters.city != null) {
            city = "/" +  this.slugify(this.filters.city)
        }

        if ( this.filters.district && this.filters.district.length > 0 ) {
            district = this.slugify(this.filters.district[0])
        }

        if ( this.filters.property_type && this.filters.property_type.length > 0 ) {
            property_type = "/" + this.slugify(this.filters.property_type[0])
        }

        var url = "/" + business + property_type + city
        if (district != "") {
            url += "/" + this.slugify(district);
        }

        if ( this.filters.address != "" && this.filters.address != null) {
            url += "/" +  this.slugify(this.filters.address)
        }

        return this.old_site_url + url;


    },

    clearFilter(business_change = false) {

        if (!business_change) {
            this.filters.business= "Vendas"
            this.filters.business_subfilter= "Residencial"
        }
        
        this.filters.reference= null
        this.filters.city= null
        this.filters.district= []
        this.filters.property_type= []
        this.filters.property_type_combo= []
        this.filters.bedrooms= []
        this.filters.garage= []
        this.filters.price_max= null
        this.filters.price_min= null
        this.filters.address= null

        if (typeof this.$refs['vselectsearchby'] != "undefined") {
            this.$refs['vselectsearchby'].$children[0].clearSelection()
        }

        if (typeof this.$refs['vselectpropertytype'] != "undefined") {
            //this.$refs['vselectpropertytype'].$children[0].clearSelection()
        }

        if (typeof this.$refs['vselectcity'] != "undefined") {
            this.$refs['vselectcity'].$children[0].clearSelection()
        }

        if (typeof this.$refs['vselectdistrict'] != "undefined") {
            //this.$refs['vselectdistrict'].$children[0].clearSelection()
        }

    },

    loadExistingFilters(reload_filters = false) {

        let advanced_filters = this.clearFilterOnOpen ? {} : this.$advanced_filters
        let use_filters = reload_filters ? JSON.parse(JSON.stringify(this.filters)) : advanced_filters

        if (!use_filters) {
            return false
        }

        console.log("filters to apply: ", use_filters)

        this.$refs['vselectcity'].$children[0].updateValue('')
        setTimeout(() => {
            Object.keys(use_filters).forEach((key, i)=>{
            
                //this.filters[key] = use_filters[key]
                Vue.set(this.filters, key, use_filters[key])

                if ( key == "city" && use_filters[key]) {
                    this.$refs['vselectcity'].$children[0].updateValue(use_filters[key])
                }
            })

            if ( use_filters['property_type_combo'] && use_filters['property_type_combo'].length > 0 ) {
                
                use_filters['property_type_combo'].forEach((type_combo) => {

                    let types_in_combo = type_combo.split('|')
                    types_in_combo.forEach((type)=>{
                        type = type.trim()
                        if ( this.filters['property_type'].indexOf(type) == -1 &&  type != "Condominio" ) {
                            this.filters['property_type'].push(type)
                        }
                    })

                })

            }

        }, 500);

    },

    set_advanced_filters(use) {
        this.use_advanced_filters = use
        this.show_other_types = true
    },

    toggleFranchiseeRegisterSection() {
      this.showFranchiseeRegister = !this.showFranchiseeRegister;
      this.$emit("toggle-franchisee-register", this.showFranchiseeRegister);
    },

    toggleFranchiseeSectionWithOption(option) {
        if (option === 'Residencial') {
            this.filters.business = 'Vendas';
        } else if (option === 'Mensal') {
            this.filters.business = 'Locacao';
        }
        this.filters.business_subfilter = option;
        this.clearFilter(true);
        this.toggleFranchiseeRegisterSection();
    },

  },

  
  mounted() {
    this.filters.business = "Vendas"

    PropertiesService.getFilters(this.data_index)
    .then(
        response => {
            //this.filters_options.cities = response.data.cities
            this.filters_options.types = response.data.types
            this.filters_options.references = response.data.referencias
            this.filters_options.adresses = response.data.enderecos

            let cities = []
            let districts = []
            let address = []

            //adjusted to place curitiba on first position
            let curitiba_obj = response.data.cities.filter(city_obj => city_obj.city == 'Curitiba')
            let other_cities = response.data.cities.filter(city_obj => city_obj.city != 'Curitiba')
            this.filters_options.cities = curitiba_obj.concat(other_cities)

            this.filters_options.cities.forEach((city)=>{
                cities.push(city.city)
                city.districts.forEach((district)=>{
                    districts.push(`${district}, ${city.city}`)
                })
            })

            response.data.enderecos.forEach((addrs)=>{
                let _address_without_number = `${addrs.address}, ${addrs.district}, ${addrs.city}`
                let _address_with_number = `${addrs.address}, ${addrs.number}, ${addrs.district}, ${addrs.city}`

                if ( address.indexOf(_address_without_number) == -1 ) {
                    address.push(_address_without_number)
                }

                if ( address.indexOf(_address_with_number) == -1 ) {
                    address.push(_address_with_number)
                }
            })


            this.filters_options.open_search = cities.concat(districts, address, this.filters_options.references)

            //se for espanhol/paragua não utilizar districts/bairros
            if ( this.lang=='es' ) {
                this.filters_options.open_search = cities.concat(address, this.filters_options.references)
            }
            

            this.loadExistingFilters()
        }
    )


    document.querySelector(".home-search-component").addEventListener("click",(e)=>{
        let el_is_property_type = e.target.closest(".property-types-wrapper")
        let el_is_trigger = e.target.closest(".trigger-property-types")
        if (!el_is_property_type && !el_is_trigger) {
            this.checkPropertyTypeHidden()
        }
    })

  },

  watch:{
    openAdvanced: function(openAdvanced) {
      //this.search(filters)
      this.use_advanced_filters = openAdvanced
    },
  }

};
</script>